export const colors = {
  ink: '#0F3D2E',
  leaf: '#1F5A43',
  gold: '#C9A14A',
  goldSoft: '#F4EBD8',
  sand: '#FFFDF7',
  border: '#E6D8BE',
  muted: '#6E6254',
  white: '#FFFFFF',
  rust: '#B85C38',
};

export const pageMaxWidth = 1180;

export const shared = {
  page: {
    minHeight: '100vh',
    width: '100%',
    backgroundColor: colors.sand,
    color: colors.ink,
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
    overflowX: 'hidden',
    boxSizing: 'border-box',
  },
  container: {
    width: '100%',
    maxWidth: `${pageMaxWidth}px`,
    margin: '0 auto',
    padding: '0 24px',
    boxSizing: 'border-box',

    '@media (max-width: 768px)': {
      padding: '0 20px',
    },

    '@media (max-width: 520px)': {
      padding: '0 16px',
    },
  },
  navPage: {
    width: '100%',
    maxWidth: `${pageMaxWidth}px`,
    margin: '0 auto',
    padding: '64px 24px 78px',
    boxSizing: 'border-box',

    '@media (max-width: 768px)': {
      padding: '46px 20px 64px',
    },

    '@media (max-width: 520px)': {
      padding: '36px 16px 54px',
    },
  },
  eyebrow: {
    margin: '0 0 10px',
    color: colors.gold,
    fontSize: '0.76rem',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  sectionTitle: {
    margin: 0,
    color: colors.ink,
    fontSize: '2.2rem',
    fontWeight: '900',
    lineHeight: 1.16,
    letterSpacing: 0,

    '@media (max-width: 520px)': {
      fontSize: '1.7rem',
    },
  },
  sectionText: {
    margin: 0,
    color: colors.muted,
    fontSize: '1rem',
    lineHeight: 1.75,
  },
  primaryButton: {
    padding: '15px 22px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: colors.gold,
    color: colors.ink,
    fontSize: '1rem',
    fontWeight: '900',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  secondaryButton: {
    padding: '15px 22px',
    borderRadius: '8px',
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.white,
    color: colors.ink,
    fontSize: '1rem',
    fontWeight: '900',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
};
